import React from "react";
import { Skeleton } from "../common/Skeleton";

export function TableSkeleton({
  rows = 8,
  columns = 5,
  className = "",
  rowClassName = "",
}) {
  return (
    <div className={`w-full overflow-hidden rounded-lg border border-border-primary ${className}`}>
      <div className="flex gap-4 border-b border-border-primary bg-bg-secondary px-4 py-3">
        {Array.from({ length: columns }).map((_, i) => (
          <Skeleton key={`h-${i}`} className="h-4 flex-1" />
        ))}
      </div>
      <div className="divide-y divide-border-primary bg-bg-primary">
        {Array.from({ length: rows }).map((_, r) => (
          <div key={`r-${r}`} className={`flex gap-4 px-4 py-3 ${rowClassName}`}>
            {Array.from({ length: columns }).map((_, c) => (
              <Skeleton key={`c-${r}-${c}`} className="h-4 flex-1" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default TableSkeleton;
